"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToggleChips = ToggleChips;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const ToggleChip_1 = require("./ToggleChip");
const Css_1 = require("../Css");
const useTestIds_1 = require("../utils/useTestIds");
/** Renders a list of `Chip`s, with wrapping & appropriate margin between each `Chip`. */
function ToggleChips(props) {
    const { values, getLabel, onRemove, xss } = props;
    const tid = (0, useTestIds_1.useTestIds)(props, "toggleChips");
    return ((0, jsx_runtime_1.jsx)("div", { css: { ...Css_1.Css.df.add("flexWrap", "wrap").gap1.$, ...xss }, ...tid, children: values.map((value) => ((0, jsx_runtime_1.jsx)(ToggleChip_1.ToggleChip, { text: getLabel(value), onClick: () => onRemove(value), ...tid.chip }, getLabel(value)))) }));
}
